<div class="tw-flex tw-items-center tw-gap-4">
  <div class="tw-w-full">
    <p-dropdown
      [options]="options"
      optionLabel="name"
      [formControl]="periodControl"
      [showClear]="false"
      class="comparison-dropdown"
      styleClass="tw-w-full"
    >
      <ng-template
        let-selectedItem
        pTemplate="selectedItem"
      >
        <div class="tw-flex tw-flex-col">
          <span
            *ngIf="selectedItem?.name"
            class="tw-text-gray-900"
            [ngClass]="{ 'tw-text-base': !dateRange, 'tw-text-sm': dateRange }"
          >
            {{ selectedItem.name }}
          </span>
          <span
            *ngIf="dateRange"
            class="tw-text-xs tw-text-gray-500"
          >
            {{ dateRange }}
          </span>
        </div>
      </ng-template>
    </p-dropdown>
  </div>

  <div *ngIf="periodControl.value?.value === 'custom' && datePickerPosition === 'right'">
    <date-range-picker
      [formControl]="datePickerControl"
      [firstDayOfWeek]="queryFirstDayOfWeek"
    ></date-range-picker>
  </div>
</div>

<div
  *ngIf="periodControl.value?.value === 'custom' && datePickerPosition === 'bottom'"
  class="tw-mt-3"
>
  <date-range-picker
    [formControl]="datePickerControl"
    [firstDayOfWeek]="queryFirstDayOfWeek"
    class="tw-w-full"
  ></date-range-picker>
</div>
